@for (section of menu?.menuSections; track section) {
  <h6 class="mainnav__caption mt-3 px-3 fw-bold">{{section.title}}</h6>
  <ul class="mainnav__menu nav flex-column">
    @for (link of section.links; track link) {
      <li class="nav-item" (click)="action($event, link)">
        <a href="#" class="nav-link mininav-toggle collapsed">@if (link.icon) {
          <i class="fs-5 me-2 fa-fw"
          [ngClass]="link.icon"></i>
        }
        <span class="nav-label mininav-content">{{link.title}}</span>
      </a>
    </li>
  }
</ul>
}

@if (stress) {
  <h6 class="mainnav__caption mt-3 px-3 fw-bold">Stress</h6>
  <ul class="mainnav__menu nav flex-column">
    <li class="nav-item" (click)="stressService.logarithmic(rounds, pages)">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">Logarithmic</span>
      </a>
    </li>
    <li class="nav-item" (click)="stressService.linear(rounds, pages)">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">Linear</span>
      </a>
    </li>
    <li class="nav-item" (click)="stressService.exponential(rounds/2, pages)">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">Exponential</span>
      </a>
    </li>
    <li class="nav-item" (click)="stressService.modulus(rounds, pages)">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">Modulus</span>
      </a>
    </li>
    <li class="nav-item" (click)="stressService.random(rounds, pages)">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">Random</span>
      </a>
    </li>
  </ul>
}

@if (style) {
  <h6 class="mainnav__caption mt-3 px-3 fw-bold">Style</h6>
  <ul class="mainnav__menu nav flex-column">
    <li class="nav-item" (click)="styleService.setStyle('gray')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">gray</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('navy')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">navy</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('ocean')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">ocean</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('lime')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">lime</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('violet')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">violet</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('orange')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">orange</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('teal')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">teal</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('corn')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">corn</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('cherry')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">cherry</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('coffee')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">coffee</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('pear')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">pear</span>
      </a>
    </li>
    <li class="nav-item" (click)="styleService.setStyle('night')">
      <a href="#" class="nav-link mininav-toggle collapsed">
        <span class="nav-label mininav-content">night</span>
      </a>
    </li>
  </ul>
}
